<template>
    <div id="letDownScreen">
        <div id="letDown">
            <div class="letDownWrap">
                <div class="logoTitle">
                    <img class="logo"
                         src="@/assets/images/footballAssociation.png"
                         alt="">
                    <img class="title"
                         src="@/assets/images/title_picture.png"
                         alt="">
                </div>
                <div class="letDownBox" >
                    <div class="title" style="position: relative">
                        <h2 style="display: flex;align-items: center">
                            <span  @click="iconBack" style="display: flex;align-items: center">
                                <v-icon name="regular/arrow-alt-circle-left" scale="1.5" style="margin-right: 15px;cursor: pointer"></v-icon>
                            </span>
                            <span>等级教练员资质认证失信人员名单公布</span>
                        </h2>
                        <el-button type="success" class="yioks-btn" @click="handleChecked">失信人员申诉</el-button>
                        <el-button type="success" class="yioks-btn" @click="findProcess">失信人员申诉审核进度</el-button>
                    </div>
                    <div class="searchWrap">
                        <div class="search">
                            <div class="wrap">
                                <input v-model.lazy="search.keywords"
                                       type="text"
                                       placeholder="请输入姓名或者证件号进行搜索"
                                       @keyup.enter="getRequest">
                                <div v-show="search.keywords!=''"
                                     class="close"
                                     @click="hideIcon">
                                    <v-icon name="regular/times-circle"
                                            scale="1.2"></v-icon>
                                </div>
                                <div class="searchBtn"
                                     @click="getRequest">搜索
                                </div>
                            </div>
                            <div>
                                <span style="color:#4CD964;cursor:pointer"> <a href="http://www.thecfa.cn/qttz/20201222/29177.html" target="_blank">《中国足球协会等级教练员资质认证材料涉假行为管理办法》（试行）</a></span>
                            </div>
                        </div>
                    </div>
                    <div class="register">
                        <template v-if="!isLoading">
                            <template v-if="showList">
                                <div class="table">
                                    <div class="thead">
                                        <div class="tr">
                                            <div class="th num"><strong>序号</strong></div>
                                            <div class="th name"><strong>姓名</strong></div>
                                            <div class="th sex"><strong>性别</strong></div>
                                            <div class="th id_number"><strong>证件号</strong></div>
                                            <div class="th behavior"><strong>处罚行为</strong></div>
                                            <div class="th banned_time"><strong>解禁日期</strong></div>
                                        </div>
                                    </div>
                                    <div class="scrollArea" v-if="showList">
                                        <vue-scroll :ops="ops" ref="vs">
                                            <div class="infinite-list-wrapper" style="overflow:auto">
                                                <ul
                                                  class="infinite-list"
                                                  v-infinite-scroll="load" style="overflow:auto">
                                                    <div class="tbodyWrap">
                                                        <div class="tbody">
                                                            <div class="tr"
                                                                 v-for="(item, index) in letList"
                                                                 :key="index">
                                                                <div class="td num">
                                                                    <p>{{ index + 1 }}</p>
                                                                </div>
                                                                <div class="td name">
                                                                    <p>{{ item.name }}</p>
                                                                </div>
                                                                <div class="td sex">
                                                                    <p>{{item.sex || '--'}}</p>
                                                                </div>
                                                                <div class="td id_number">
                                                                    <p>{{ item.id_number||"--" }}</p>
                                                                </div>
                                                                <div class="td behavior">
                                                                    <p>{{item.behavior || '--'}}</p>
                                                                </div>
                                                                <div class="td banned_time">
                                                                    <p>{{item.end_date || '永久'}}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </ul>
                                            </div>
                                        </vue-scroll>
                                    </div>
                                </div>
                            </template>
                            <yioks-empty v-show="showEmpty"></yioks-empty>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <app-footer></app-footer>
        <el-dialog
          class="detail-info-dia"
          title="查询失信人员申诉审核进度"
          :visible.sync="showDialog"
          :close-on-click-modal="false"
          width="460px"
          top="25vh"
        >
            <el-form
              label-width="90px"
              ref="formData"
              :model="formData"
              :rules="rules"
              style="padding-right: 20px"
            >
                <el-row>
                    <el-form-item label="证件号" prop="id_number">
                        <el-input placeholder="请输入证件号" v-model.trim="formData.id_number"></el-input>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="查询码" prop="the_query_code">
                        <el-input placeholder="请输入查询码" v-model.trim="formData.the_query_code"></el-input>
                    </el-form-item>
                </el-row>
                <el-row style="text-align: center">
                    <el-button type="primary" @click="jumpRecoder">立即查询</el-button>
                </el-row>
            </el-form>
        </el-dialog>
        <yioks-tips  :showTips="tipsFlag"
                     tips="申请人对被列入“失信名单”的决定不服的，可以自收到告知通知或名单在中国足协官网公示之日起5个工作日内，向中国足协提交书面申诉申请以及相关证据。中国足协应自收到申诉申请及证据之日起20个工作日内组织审查，经审查理由成立的，将在确认后的3个工作日内予以纠正；理由不成立的，驳回申请，且不得再次提交申请，并延长其限制参加相关教练员培训活动12个月。"
                     :loading="repeatSubmit"
                     @hideTips="hideTipsDialog"></yioks-tips>
    </div>
</template>

<script>
  import ops from '@/assets/js/vuescrollOption';
  import { letDownList } from "@/api/common/login";
    export default {
        name: "LetDownList",
        data() {
            return {
              ops: ops(),
              showDialog: false,
              isLoading: false,
              showList: false,
              yzuobiao: 0,
              letList: [],
              loading: false,
              showEmpty: false,
              search: {
                keywords:''
              },
              formData: {
                id_number: "",
                the_query_code: ""
              },
              rules: {
                id_number: [
                  {
                    required: true,
                    validator: (rule, val, callback) => {
                      if (!val) {
                        callback(new Error("请输入证件号"));
                      } else {
                        callback();
                      }
                    },
                    trigger: "blur"
                  }
                ],
                the_query_code: [
                  { required: true, message: "请输入查询码", trigger: "blur" }
                ]
              },
              tipsFlag: false,
              repeatSubmit: false,
            };
        },
        components: {
          "app-footer": () => import("@/components/LayOut/Common/Footer"),
          "v-icon": () => import("vue-awesome/components/Icon"),
          "yioks-empty": () => import("@/components/Tips/Empty"),
          "yioks-tips": () => import('@/components/Tips/Dialog'),
        },
        created() {
          this.request();
        },
        methods:{
          load(){
          },
          iconBack() {
            this.$router.back();
          },
          request() {
              this.isLoading = true;
              letDownList({...this.search})
                .then(res=>{
                    if (res.data.status===0 ){
                        const {result} = res.data;
                        if(result.list.length > 0){
                            this.letList = result.list;
                            this.showList = true;
                            this.showEmpty = false;
                            this.isLoading = false;
                            this.letList.forEach(item =>{
                                let behaviorShow = '';
                                if(item.behavior){
                                    const temList = JSON.parse(item.behavior)
                                    temList.forEach(letTmp =>{
                                        if(letTmp){
                                            let tmp1 = letTmp[0] + '/' +letTmp[1] +'，'
                                            behaviorShow = behaviorShow + tmp1;
                                        }
                                    })
                                }
                                behaviorShow = behaviorShow.substr(0, behaviorShow.length - 1);
                                item.behavior=behaviorShow;
                            });
                        }
                    } else{
                        this.$message.error(res.data.msg);
                        this.isLoading = false;
                    }
                })
                .catch(err=>{
                    this.isLoading = false;
                    console.error(err);
                })
          },
          getRequest() {
            this.changeQuery(true);
          },
          changeQuery(flag) {
             flag && (this.page = 1);
             this.$router.replace({
                    path: this.$route.path,
                    query: {
                        ...this.$route.query,
                        keywords: this.search.keywords
                    }
             });
             this.request();
          },
          hideIcon() {
              this.$set(this.search, "keywords", "");
              this.getRequest();
          },
          handleChecked() {
            this.tipsFlag = true;
            this.repeatSubmit = false;
          },
          hideTipsDialog(bool,flag){
                const that = this;
                if (flag){
                    that.$router.push("/dishonestPeopleAppealAdd");
                }else{
                    that.repeatSubmit=false;
                    that.tipsFlag=false
                }
          },
          findProcess() {
            this.showDialog = true;
          },
          jumpRecoder() {
            this.$refs["formData"].validate(valid => {
              if (valid) {
                this.showDialog = false;
                this.$router.push({
                  path: "/coachAppealInfo",
                  query: {
                    id_number: this.formData.id_number,
                    the_query_code: this.formData.the_query_code.toUpperCase()
                  }
                });
              } else {
                this.$message.error("请填写所有带*号的必填项");
              }
            });
          }
        }
    };
</script>

<style lang="stylus" scoped>
    @import '~@/assets/css/variable';
    #letDownScreen {
        width: 100%;
        height: 100%;
        #letDown {
            height: calc(100% - 60px);
            display: flex;
            justify-content: center;
            user-select: none;
            .letDownWrap {
                width: 1024px;
                padding: 95px 0 0;
                display: flex;
                flex-direction: column;
                .logoTitle {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin: 0 0 50px 0;
                    .logo {
                        width: 120px;
                        height: 120px;
                        margin: 0 15px 0 0;
                    }
                }
                .letDownBox {
                    align-self: center;
                    width: 900px;
                    height: 550px;
                    padding: 0 25px;
                    background-color: $block_bg_color_base;
                    box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.2);
                    position: relative;
                    color: $color_white;
                    .title{
                        display flex
                        justify-content space-between
                        margin: 30px 0 10px 0;
                        border-bottom: 2px solid;
                        padding-bottom: 10px;
                        h2{
                            font-size: 25px;
                        }
                    }
                    .searchWrap {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        height: 40px;
                        margin: 0 20px;
                        .search {
                            width: 100%;
                            height: 100%;
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            .wrap {
                                height: 100%;
                                display flex
                                position: relative;
                                input {
                                    width: 230px;
                                    height: 100%;
                                    padding: 0 20px;
                                    font-size: $font_size_medium;
                                    color: $color_black;
                                    outline: none;
                                }
                                .close {
                                    position: absolute;
                                    right: 95px;
                                    top: 10px;
                                    color: $color_info;
                                    cursor: pointer;
                                }
                                .searchBtn {
                                    width: 90px;
                                    height: 100%;
                                    display: flex;
                                    justify-content: center;
                                    align-items: center;
                                    font-size: 20px;
                                    background-color: $color_suc;
                                    cursor: pointer;

                                }
                            }
                        }
                    }
                    .register{
                        #empty {
                            height: 400px;
                        }
                        .table {
                            width: 100%;
                            margin: 10px 0 0;
                            .thead, .tbody {
                                border: 1px solid $color_white;
                            }
                            .thead {
                                margin: 0 20px;
                                .tr {
                                    height: 45px;
                                    display: flex;
                                }
                            }
                            .scrollArea {
                                height: 340px;
                            }
                            .tbodyWrap {
                                display block
                                margin-bottom 10px
                                // padding: 0 40px;
                            }
                            .tbody {
                                display block
                                margin-left 20px
                                margin-right 20px
                                border-top: none;
                                border-bottom: none;
                                .tr {
                                    min-height: 49px;
                                    display: flex;
                                    border-bottom: 1px solid $color_white;
                                }
                            }
                            .th, .td {
                                height: auto;
                                flex: 1 1 auto;
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                font-size: 16px;
                                border-right: 1px solid $color_white;
                            }
                            .th:last-child, .td:last-child {
                                border-right: none;
                            }
                            .td:last-child {
                                color: $color_suc;
                                user-select: none;
                            }
                            .td {
                                p {
                                    over_hide();
                                }
                                .showRecord{
                                    cursor pointer
                                }
                            }
                            .name {
                                width: 10%;
                            }
                            .sex {
                                width: 5%;
                            }
                            .num {
                                width: 5%;
                            }
                            .id_number {
                                width: 20%;
                            }
                            .behavior {
                                width: 35%;
                            }
                            .banned_time {
                                 width: 10%;
                             }
                        }
                    }
                }
            }
        }
    }

    .yioks-btn
        background-color: #4cd964
    .back-icon
        width 24px
        height 24px

</style>
